import { ServiceCenters } from 'feature/serviceCenters/ServiceCenters'
import { MainLayout } from 'layouts'

export function ServiceCentersPage() {
  return (
    <MainLayout>
      <div className='container'>
        <ServiceCenters />
      </div>
    </MainLayout>
  )
}
